export default {
  discover: {
    market: {
      title: 'Discover the best Agentic patterns',
      searchPlaceholder: 'Find your next agentic workflow template...',
      tabs: {
        template: '模板',
        buildIn: '内置',
      },
      filter: {
        mySubmissions: '我提交的',
        sortBy: '排序方式',
        updatedTime: '更新时间',
        usageCount: '使用次数',
      },
      categories: {
        database: '数据库',
        model: '模型',
        productivity: '生产力',
        creative: '创意',
      },
    },
    detail: {
      installs: '次安装',
      install: '安装',
      useTemplate: '使用模板',
      tabs: {
        overview: '概览',
      },
      configuration: '配置',
      category: '分类',
      tags: '标签',
      currentVersion: '当前版本',
      versionHistory: '版本历史',
      creditsInfo: '积分信息',
      copyCost: '复制消耗',
      authorReward: '作者获得奖励',
      credits: '积分',
      messages: {
        installSuccessOwner: '安装成功（作为所有者不扣除积分）',
        insufficientCredits: '积分不足',
        copying: '正在复制到工作空间...',
        copySuccess: '复制成功！',
      },
    },
  },
};
